/**
 * Single source of truth for "which types use the docked, single-canvas
 * visualizer" and the one stable canvas id that canvas carries for its whole
 * life. Kept in a tiny leaf module (no heavy imports) so both the visualizer
 * base class and appLayout can import it without a circular dependency.
 */

/** The ONE id the docked <canvas> uses across every route. Never changes, so
 *  navigation can bind getElementById(DOCKED_CANVAS_ID) once. */
export const DOCKED_CANVAS_ID = "qkbDockedCanvas";

/** Dock slot names, one per QKB page that shows the visualizer. */
export const DOCK_SLOTS = {
  visualizer: "qkb-visualizer",
  materials: "qkb-materials",
  cart: "qkb-cart",
};

/** Map the legacy per-page canvasIds to their dock slot, so the old page render
 *  code (which still passes canvasId="selectionCanvas" etc.) resolves the right
 *  slot without further edits. */
export const CANVAS_ID_TO_SLOT = {
  selectionCanvas: DOCK_SLOTS.materials,
  shoppingCartDesktopCanvas: DOCK_SLOTS.cart,
};
